import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import PranicHealing from "./components/PranicHealing";
import Services from "./components/Services";
import Blogs from "./components/Blogs";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="np-app">
      <Navbar />
      <main>
        <Hero />
        <About />
        <PranicHealing />
        <Services />
        <Blogs />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
